import { ReactElement } from 'react';
import { PrimaryAppBar } from 'components/AppBar';
import { Footer, CondensedFooter } from 'components/Footer';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';
import { isGondolaApp } from 'lib/utils/mobileAppUtils';
import { useRouter } from 'next/router';

interface Props {
  children: ReactElement;
}

export const Layout = ({ children }: Props) => {
  // Since the back button is at the bottom, and the horizontal "grab bar"
  // is present on some devices, it's good to have a little extra space
  // at the bottom of the mobile app so any content doesn't get blocked
  // when you scroll all the way down.
  const renderExtraSpaceForApp = <div className="pt-24" />;

  const router = useRouter();
  const summit = router.pathname.includes('sportssummit');
  const teamsPage = ['/teams', '/dashboard', '/teamProjects'].some((path) => router.pathname.includes(path));
  const admin = router.pathname.includes('/admin');

  const renderFooter = () => {
    if (summit) {
      return null;
    }
    if (teamsPage || admin) {
      return <CondensedFooter teams={teamsPage} />;
    }
    return <Footer />;
  };

  return (
    <>
      <div className="w-full relative flex" style={{ minHeight: summit ? '100vh' : 'calc(100vh - 112px)' }}>
        <GondolaHead
          title="Gondola: Social Credits, Portfolio, and Analytics"
          description="Gondola gives you the power to collect, organize, and track social media posts and give credit to the great minds that make them."
          url="https://gondola.cc"
        />
        <PrimaryAppBar />
        <div className="w-full pt-14">
          {children}
        </div>
      </div>
      {!isGondolaApp ? renderFooter() : renderExtraSpaceForApp}
    </>
  );
};
